import { render, staticRenderFns } from "./SchemaStringConfig.vue?vue&type=template&id=12d4f518"
import script from "./SchemaStringConfig.vue?vue&type=script&lang=js"
export * from "./SchemaStringConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports